// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mgo-","colMin":"styles_colMin__3sz_v"};